<template>
  <div class="blog-list-item-v2">
    <router-link :to="url" class="thumb">
      <img :src="thumb" :alt="`${post[`title_${locale}`]}`" />
    </router-link>

    <div class="description">
      <router-link :to="url">
        <h4 class="my-2">
          {{ post[`title_${locale}`] }}
        </h4>
      </router-link>
      <p v-if="post.category">{{ post.category[`title_${locale}`] }} {{ t("by Ersties") }}</p>
    </div>

    <div class="d-flex justify-content-center mt-3 mb-1">
      <router-link :to="url" class="btn btn-sm btn-primary">
        {{ t("See more") }}
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import { useI18n } from "vue-i18n";
import { getBlogThumb } from "@/utils/mediaHelper";
import { BlogPost } from "@/interfaces/Blog/BlogPost.ts";
import { useFeatureStore } from "@/store/feature.ts";
import { getCookie } from "@/utils/cookies.ts";

defineOptions({
  name: "blog-list-item-v2",
});

const props = defineProps({
  post: {
    type: Object as PropType<BlogPost>,
    required: true,
  },
});

const { locale, t } = useI18n();
const featureStore = useFeatureStore();

const hasAgeVerificationFeature = computed(() => getCookie("av_enabled") || featureStore.hasAgeVerificationFeature);
const thumb = computed(() => {
  const thumb = !hasAgeVerificationFeature.value || props.post.sfw ? props.post.thumb : props.post.sfw_thumb || props.post.thumb;
  return getBlogThumb(thumb);
});

const url = computed(() => {
  const prefix = locale.value === "de" ? "lecker_blog" : "blog";
  return `/${prefix}/${props.post.permalink}`;
});
</script>

<style lang="scss">
@import "./index";
</style>
